import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);



  const routes = [


  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  {
    path: '/potensiInvestasi',
    name: 'potensiInvestasi',
    component: () => import('../views/potensiInvestasi.vue'),
  },

  {
    path: '/faq',
    name: 'faq',
    component: () => import('../views/faq.vue'),
  },

  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
  },


]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
